import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop rank reordering. On drop, PATCH reorder with new position.
export default class extends Controller {
  connect() {
    this.initializeSortable()
  }

  initializeSortable() {
    Sortable.create(this.element, {
      animation: 150,
      ghostClass: "opacity-40",
      handle: "[data-rank-sortable-handle]",
      onEnd: (evt) => this.onRankMoved(evt),
    })
  }

  async onRankMoved(evt) {
    const rankEl = evt.item
    const reorderUrl = rankEl.dataset.reorderUrl
    if (!reorderUrl) return

    const newPosition = evt.newIndex

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const url = new URL(reorderUrl, window.location.origin)
    url.searchParams.set("position", newPosition)

    try {
      const res = await fetch(url.toString(), {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token,
          Accept: "application/json",
        },
      })

      if (!res.ok) {
        throw new Error("Failed to reorder")
      }
    } catch (err) {
      // Revert on error
      const parent = evt.from
      const children = Array.from(parent.children).filter((c) => c !== evt.item)
      const target = children[evt.oldIndex]
      target ? parent.insertBefore(evt.item, target) : parent.appendChild(evt.item)
    }
  }
}
